import React from "react";
import { connect } from "react-redux";
import {
    reduxForm,
    formValueSelector,
    Field,
    SubmissionError
} from "redux-form";
import { NEW_CLIENT_SUBMITED } from "../constants/actionTypes";
import * as agent from "../agent";
import { Source, NewLoanTypes, Office, Masks } from "../constants/enums";
import {
    MaterialTextField,
    MaterialMaskedTextField,
    MaterialCheckbox
} from "./MaterialInput";
import MaterialCombobox from "./MaterialCombobox";
import { normalizeMoney, required, validatePhone } from "../utility";
import PrimaryDivider from "./PrimaryDivider";
import SubmitButton from "./SubmitButton";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const newClientForm = ({
    brands,
    models,
    suggestionsLoaded,
    toggleForm,
    fullForm,
    handleSubmit
}) => (
    <form onSubmit={handleSubmit} autoComplete="off">
        <Grid container justify="center" spacing={16}>
            <Grid item className="common-form common-column">
                <Field
                    name="source"
                    select
                    validate={required}
                    component={MaterialTextField}
                    label="Источник"
                >
                    {Object.keys(Source).map((s, i) => (
                        <MenuItem key={i} value={s}>
                            {Source[s]}
                        </MenuItem>
                    ))}
                </Field>
                <Field
                    name="firstname"
                    component={MaterialTextField}
                    validate={required}
                    label="Имя"
                />
                <Field
                    name="car.brand"
                    component={MaterialCombobox}
                    validate={required}
                    suggestionsLoaded={suggestionsLoaded}
                    suggestions={Object.keys(brands)}
                    label="Марка автомобиля"
                />
                <Field
                    name="car.model"
                    component={MaterialCombobox}
                    validate={required}
                    suggestionsLoaded={suggestionsLoaded}
                    suggestions={models}
                    label="Модель автомобиля"
                />
                <Field
                    name="car.year"
                    component={MaterialMaskedTextField}
                    mask={Masks.year}
                    label="Год выпуска"
                />
                <FormControlLabel
                    control={
                        <Field
                            name="isJuridicalPerson"
                            component={MaterialCheckbox}
                        />
                    }
                    label="Юридическое лицо"
                />
            </Grid>
            <Grid item className="common-form common-column">
                <Field
                    component={MaterialTextField}
                    name="loan.value"
                    normalize={normalizeMoney}
                    validate={required}
                    endAdornment="₽"
                    label="Сумма займа"
                />
                <Field
                    name="loan.type"
                    validate={required}
                    select
                    component={MaterialTextField}
                    label="Программа"
                >
                    {Object.keys(NewLoanTypes).map((t, i) => (
                        <MenuItem key={i} value={t}>
                            {NewLoanTypes[t]}
                        </MenuItem>
                    ))}
                </Field>
                <Field
                    name="loan.office"
                    validate={required}
                    select
                    component={MaterialTextField}
                    label="Офис"
                >
                    {Object.keys(Office).map((o, j) => (
                        <MenuItem key={j} value={o}>
                            {Office[o]}
                        </MenuItem>
                    ))}
                    <MenuItem value="NOT_SURE">Не определился</MenuItem>
                </Field>
                <Field
                    name="phone"
                    component={MaterialMaskedTextField}
                    mask={Masks.phone}
                    validate={validatePhone}
                    placeholder="+7 (___) ___-__-__"
                    label="Номер телефона"
                />
                <Field
                    name="comment"
                    rows={5}
                    multiline
                    component={MaterialTextField}
                    label="Комментарий"
                />
            </Grid>
        </Grid>
        <Grid container justify="center">
            <IconButton onClick={toggleForm}>
                {fullForm ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
        </Grid>
        <Collapse in={fullForm} classes={{ container: "collapse-wrapper" }}>
            <Grid container justify="center" spacing={16}>
                <Grid item className="common-form common-column">
                    <Field
                        name="secondname"
                        component={MaterialTextField}
                        label="Фамилия"
                    />
                    <Field
                        name="thirdname"
                        component={MaterialTextField}
                        label="Отчество"
                    />
                    <Field
                        name="birthDate"
                        component={MaterialMaskedTextField}
                        mask={Masks.date}
                        label="Дата рождения"
                    />
                    <Field
                        name="address"
                        component={MaterialTextField}
                        label="Регион регистрации"
                    />
                </Grid>
                <Grid item className="common-form common-column">
                    <Field
                        component={MaterialTextField}
                        name="loan.duration"
                        select
                        label="Срок займа"
                    >
                        {Array(36)
                            .fill(0)
                            .map((_, i) => (
                                <MenuItem key={i} value={i + 1}>
                                    {i + 1} мес.
                                </MenuItem>
                            ))}
                    </Field>
                    <Field
                        name="email"
                        component={MaterialTextField}
                        label="Электронный адрес"
                    />
                    <Field
                        name="passport.serie"
                        component={MaterialMaskedTextField}
                        mask={Masks.passportSerie}
                        label="Серия паспорта"
                    />
                    <Field
                        name="passport.number"
                        component={MaterialMaskedTextField}
                        mask={Masks.passportNumber}
                        label="Номер паспорта"
                    />
                </Grid>
            </Grid>
        </Collapse>
        <SubmitButton label="Отправить Заявку" />
    </form>
);

const NewClientForm = connect((state, props) => {
    const { brands } = props;
    const brand = formValueSelector("new-client-form")(state, "car.brand");
    return {
        models: (brands[brand] || []).map(m => m.model)
    };
})(
    reduxForm({
        form: "new-client-form",
        enableReinitialize: true
    })(newClientForm)
);

class NewClient extends React.Component {
    state = {
        brands: [],
        suggestionsLoaded: false,
        fullForm: false
    };

    componentWillMount = () => this.fetchData();

    toggleForm = () => {
        const { fullForm } = this.state;
        this.setState({ fullForm: !fullForm });
    };

    fetchData = () => {
        agent.Cars.brands()
            .then(res => {
                this.setState({ brands: res, suggestionsLoaded: true });
            })
            .catch(e => alert(e.message));
    };

    render() {
        const { onSubmit } = this.props;
        const { brands, fullForm, suggestionsLoaded } = this.state;
        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">Новая заявка</Typography>
                    <PrimaryDivider />
                    <Paper className="common-paper mb20">
                        <NewClientForm
                            brands={brands}
                            toggleForm={this.toggleForm}
                            suggestionsLoaded={suggestionsLoaded}
                            fullForm={fullForm}
                            onSubmit={onSubmit}
                        />
                    </Paper>
                </React.Fragment>
            </Fade>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    onSubmit: client =>
        agent.Clients.create(client)
            .then(res => dispatch({ type: NEW_CLIENT_SUBMITED, payload: res }))
            .catch(err => {
                const { cars = {}, ...rest } = err.errors;
                const car = cars["0"] || {};
                const { loan } = car;
                return Promise.reject(
                    new SubmissionError({
                        car,
                        loan,
                        ...rest
                    })
                );
            })
});

export default connect(null, mapDispatchToProps)(NewClient);



// WEBPACK FOOTER //
// ./src/components/NewClient.js